import './global';

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Import Vendor Scripts
// Note: We need to ensure these are loaded after jQuery
// Since we are importing them, webpack bundles them. 
// Some might fail if they rely on global $ being available immediately at import time, 
// but since we set window.$ above, it might work if they are CommonJS compatible or just scripts.
// If they are just scripts, importing them executes them.
// We will import the key ones. 
import './assets/vendor/js/bundle.min.js';

// Revolution Slider scripts removed from import to avoid webpack resolution errors.
// They will be loaded dynamically from public folder.

// Extensions (we need to rename these too if we want to import them cleanly, but for now let's skip or handle later if needed)
// Actually, let's just import the main ones. The extensions might be auto-loaded or needed explicitly.
// If they are needed, we should rename and import them.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
